import React from "react";
import unternehmensprofil from "../assets/unternehmensprofil.svg";
import expertenprofil from "../assets/expertenprofil.svg";

export default function MyProfilSelect() {
    return (
        <div id='ProfilSelect'>
            <div className='big-title'>Mein bergisch.metall</div>
            <div className='container'>
                <div className='right-part'></div>
            </div>
        </div>
    );
}
